import EventProgressBarContainer from '../../atoms/container/eventProgressBarContainer';
import EventProgressBarInnerBar from '../../atoms/container/eventProgressBarInnerBar';

function EventProgressBar({
  color,
  percentage,
}: {
  color?: string;
  percentage: number;
}) {
  return (
    <EventProgressBarContainer>
      <EventProgressBarInnerBar
        color={color}
        width={isNaN(percentage) ? 0 : percentage}
      />
    </EventProgressBarContainer>
  );
}

export default EventProgressBar;
